import { useCallback } from "react";
import BulkUploadDropzone from "../BulkUploadDropzone";
import AgentSelection from "../AgentSelection";
import { useBulkUpload } from "@/contexts/uploads/BulkUploadContext";
import { UploadComponentProps } from "./types";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

type UploadBulkProps = UploadComponentProps;

const UploadBulk = ({ availableAgents, selectedAgentId, onAgentSelect }: UploadBulkProps) => {
  const { setAgent } = useBulkUpload();

  const handleAgentSelectWithSync = useCallback(
    (agentId: string) => {
      onAgentSelect(agentId);
      // Sync to bulk upload context
      if (agentId === "none") {
        setAgent({ id: undefined, name: undefined });
      } else {
        const agent = availableAgents.find((a) => a.id === agentId);
        setAgent({ id: agentId, name: agent?.name });
      }
    },
    [onAgentSelect, setAgent, availableAgents],
  );

  return (
    <>
      <AgentSelection
        agents={availableAgents}
        selectedAgentId={selectedAgentId}
        onAgentSelect={handleAgentSelectWithSync}
      />
      <div className="flex flex-col items-center justify-center h-full max-w-2xl mx-auto">
        <GenieIcon name="files" size={64} color="#4E9CFF" gradientEnabled className="mb-4" />
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">Bulk Upload</h3>
        <p className="text-sm text-gray-600 mb-6 text-center">
          Upload multiple files at once - PDFs, Word docs, text files, and more
        </p>
        <BulkUploadDropzone />
      </div>
    </>
  );
};

export default UploadBulk;
